var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconDownload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 1.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "#757577",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 9 17.001562 L 15 17.001562 ",
    transform: "matrix(0.833333,0,0,0.833333,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 1.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "#757577",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 12 6 L 12 12.998437 M 12 12.998437 L 15.501562 9.501563 M 12 12.998437 L 8.498437 9.501563 ",
    transform: "matrix(0.833333,0,0,0.833333,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 1.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "#757577",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 12 21.998437 C 17.521875 21.998437 21.998437 17.521875 21.998437 12 C 21.998437 6.478125 17.521875 2.001562 12 2.001562 C 6.478125 2.001562 2.001562 6.478125 2.001562 12 C 2.001562 17.521875 6.478125 21.998437 12 21.998437 Z M 12 21.998437 ",
    transform: "matrix(0.833333,0,0,0.833333,0,0)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDownload);
export default __webpack_public_path__ + "static/media/icon-download.50f2584ec71600c650dece9d9f517acf.svg";
export { ForwardRef as ReactComponent };